import React from "react";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import "../../../../styles/dashboard/third-party/ThirdPartyIndex.css";
import {
  RazorCopyText,
  RazorDateTime,
  RazorNumberFormat,
  RazorTextTrim,
  RazorToolTip,
  RazorGetValue,
} from "../../../../components/razor-reuse";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import { capitalizeFirstLetter } from "../../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
}

const NGNAccountDetailsModal = ({ onClose, visible }: myComponentProps) => {
  const { blaze } = useSelector((state: RootState) => state.thirdParty);

  const objListToView = [
    {
      label: "Bank Name",
      key: "bank_name",
      value: "",
      copy: true,
    },
    {
      label: "Account Name",
      key: "account_name",
      value: "",
      copy: true,
    },
    {
      label: "Account Number",
      key: "account_number",
      value: "",
      copy: true,
    },
    {
      label: "Payment Method",
      key: "payment_method",
      value: "",
      copy: true,
    },
  ];

  return (
    <>
      <ReuseModal
        title="NGN Blaze Acount Details"
        visible={visible}
        onClose={onClose}
        hideBtn
      >
        <div
          // onClick={() => {
          //   console.log(blaze);
          // }}
          className="third-party-account-details-modal-wrap-index"
        >
          <div className="title-text-box">
            <p className="title">Fund Account</p>
            <p className="text">
              Make payment from your bank to the details below
            </p>
          </div>
          {/* wrapper start */}
          <div className="label-value-box-wrap">
            {RazorGetValue(
              objListToView,
              blaze?.ngn_details?.payment_details
            )?.map((chi: any, idx) => {
              if (chi?.hide || !chi?.value) {
                return <React.Fragment key={idx}></React.Fragment>;
              }
              return (
                <div key={idx} className="label-value-box">
                  <p className="label">{chi?.label}:</p>
                  <div
                    className={`value ${
                      String(chi?.value)?.length > 25 && !chi?.date
                        ? "tooltip-hover-wrap"
                        : ""
                    }`}
                    style={{ color: chi?.color ? chi?.color : "" }}
                  >
                    {chi?.date ? (
                      <RazorDateTime date={chi?.value} hideAgo />
                    ) : chi?.amount ? (
                      chi?.copy ? (
                        <RazorCopyText
                          textToCopy={RazorNumberFormat(chi?.value, {
                            symbol: chi?.symbol,
                            numberAbbreviate: String(chi?.value)?.length > 8,
                          })}
                          reference={RazorNumberFormat(chi?.value, {
                            symbol: chi?.symbol,
                            numberAbbreviate: String(chi?.value)?.length > 8,
                          })}
                          outerCopy
                        />
                      ) : (
                        RazorNumberFormat(chi?.value, {
                          symbol: chi?.symbol,
                          numberAbbreviate: String(chi?.value)?.length > 8,
                        })
                      )
                    ) : chi?.copy ? (
                      <RazorCopyText
                        textToCopy={chi?.value}
                        reference={RazorTextTrim(
                          capitalizeFirstLetter(chi?.value),
                          25
                        )}
                        outerCopy
                      />
                    ) : (
                      RazorTextTrim(chi?.value, 25) || "---"
                    )}
                    <RazorToolTip
                      color="black-light"
                      text={chi?.value}
                      position={`top-center`}
                    />
                  </div>
                </div>
              );
            })}
            {/* label-value box start  */}
            {/* <div className="label-value-box">
              <p className="label">Sender’s Name:</p>
              <p className="value">Cassandra Onyenjen</p>
            </div> */}
            {/* label-value box end */}

            {/* <RazorPreviewBox list={RazorGetValue(objListToView, '')} /> */}
          </div>
          {/* wrapper send */}
        </div>
      </ReuseModal>
    </>
  );
};

export default NGNAccountDetailsModal;
